import { FormattedHTMLMessage } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { type FormFieldComponentProps } from "@/lib/types/types";

export const EBTCardNumberComponent = ({
  value,
  isErrored,
  onChange,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("ebtCardNumber")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="ebtCardNumber"
      value={value}
      onChange={onChange}
      // There is no default ebtCardNumberPlaceholder message, using field label instead.
      placeholder={placeholder || msg({ id: "ebtCardNumber" })}
      label={<FormattedHTMLMessage id="ebtCardNumber" defaultMessage="EBT card Number" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidEBTCardNumber"
            defaultMessage="Invalid EBT Card Number"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      disabled={disabled}
    />
  );
};
